module.exports = __webpack_public_path__ + "static/img/error_top_img.e5aadaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error_top_img.png
// module id = RoWD
// module chunks = 1